export function fileUrl(filename) {
  const token = localStorage.getItem('token');
  const encodedName = encodeURIComponent(filename);
  const encodedToken = token ? encodeURIComponent(token) : '';

  return encodedToken
    ? `/api/uploads/${encodedName}?token=${encodedToken}`
    : `/api/uploads/${encodedName}`;
}
